import React from 'react';
import _ from 'lodash';

import { useFieldBulletinBoardDetail } from '../../services/fieldBulletinBoard/FieldBulletinBoardDetailContext';

import { messageUtility } from '../../utilities/messageUtility';
import FieldBulletinBoardsService from '../../services/fieldBulletinBoard/FieldBulletinBoardsService';

import { FieldBulletinBoardMasterHeader } from './FieldBulletinBoardMasterHeader';

import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import Tooltip from '@mui/material/Tooltip';

import MasterPageHeaderStyles from '../../styles/componentStyle/fieldBulletinBoard/FieldBulletinBoardMasterPageHeader.scss';
import Styles from '../../styles/componentStyle/fieldBulletinBoard/FieldBulletinBoardDetail.scss';
import { BACK_EVENT_SOURCE, DATE_TIME_FORMAT } from '../../utilities/constants';

export function FieldBulltinBoardDetailHeaderForPartner() {
  const { getDetailInfo, handleBack } = useFieldBulletinBoardDetail();

  const detail = getDetailInfo();

  return (
    <React.Fragment>
      <div className={`${Styles.detailHeaderPartner}`}>
        <div className={`${MasterPageHeaderStyles.masterPageHeader}`}>
          <FieldBulletinBoardMasterHeader
            handleBack={() => handleBack(BACK_EVENT_SOURCE.MASTER_PAGE_HEADER)}
            title={messageUtility.getMessage('I-000-166-01')}
          />
        </div>
        <div className='partner-detail-header'>
          <div className='partner-detail-header__bread-crumb'>
            <KeyboardArrowLeftIcon className='arrow-icon' />
            <button
              className='btn-text--sm'
              onClick={() => handleBack(BACK_EVENT_SOURCE.BREADCRUMBS)}
            >
              {messageUtility.getMessage('I-000-165-35')}
            </button>
          </div>
          {!_.isEmpty(detail) && (
            <div className='partner-detail-header__field-info'>
              <Tooltip
                title={`${messageUtility.getMessage('I-000-166-21')} ${
                  detail.company_name
                }`}
                placement='bottom'
                arrow
              >
                <div className='partner-detail-header__field-info-txt'>
                  {messageUtility.getMessage('I-000-166-21')}
                  {detail.company_name}
                </div>
              </Tooltip>
              <Tooltip
                title={`${messageUtility.getMessage('I-000-166-22')} ${
                  detail.field_name
                }`}
                placement='bottom'
                arrow
              >
                <div className='partner-detail-header__field-info-txt'>
                  {messageUtility.getMessage('I-000-166-22')}
                  {detail.field_name}
                </div>
              </Tooltip>
            </div>
          )}
          {!_.isEmpty(detail) && (
            <div className='partner-detail-header__board-info'>
              <Tooltip
                title={`${messageUtility.getMessage(
                  'I-000-166-23'
                )} ${FieldBulletinBoardsService.convertDate(
                  detail.history.created.date_time,
                  DATE_TIME_FORMAT.weekdaySlashDateFormat
                )}`}
                placement='bottom'
                arrow
              >
                <div className='partner-detail-header__created-date'>
                  {messageUtility.getMessage('I-000-166-23')}
                  {FieldBulletinBoardsService.convertDate(
                    detail.history.created.date_time,
                    DATE_TIME_FORMAT.weekdaySlashDateFormat
                  )}
                </div>
              </Tooltip>
              <Tooltip
                title={`${messageUtility.getMessage('I-000-166-24')}
                ${FieldBulletinBoardsService.convertNameAndRole(
                  detail.history.created.user_name,
                  detail.history.created.role_code
                )}`}
                placement='bottom'
                arrow
              >
                <div className='partner-detail-header__board-info-user'>
                  {messageUtility.getMessage('I-000-166-24')}
                  {FieldBulletinBoardsService.convertNameAndRole(
                    detail.history.created.user_name,
                    detail.history.created.role_code
                  )}
                </div>
              </Tooltip>
              <Tooltip
                title={`${messageUtility.getMessage('I-000-166-25')}
                ${FieldBulletinBoardsService.convertDate(
                  detail.history.updated.date_time,
                  DATE_TIME_FORMAT.weekdaySlashDateFormat
                )}`}
                placement='bottom'
                arrow
              >
                <div className='partner-detail-header__updated-date'>
                  {messageUtility.getMessage('I-000-166-25')}
                  {FieldBulletinBoardsService.convertDate(
                    detail.history.updated.date_time,
                    DATE_TIME_FORMAT.weekdaySlashDateFormat
                  )}
                </div>
              </Tooltip>
              <Tooltip
                title={`${messageUtility.getMessage('I-000-166-26')}
                ${FieldBulletinBoardsService.convertNameAndRole(
                  detail.history.updated.user_name,
                  detail.history.updated.role_code
                )}`}
                placement='bottom'
                arrow
              >
                <div className='partner-detail-header__board-info-user'>
                  {messageUtility.getMessage('I-000-166-26')}
                  {FieldBulletinBoardsService.convertNameAndRole(
                    detail.history.updated.user_name,
                    detail.history.updated.role_code
                  )}
                </div>
              </Tooltip>
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/components/fieldBulletinBoard/FieldBulletinBoardDetailHeaderDetailForPartner.jsx